module.exports = __webpack_public_path__ + "img/36.f9ab1e3e.jpg";